import Admittance from './business/admittance'

const SUB_SYSTEM = 'finance'
// 融资申请
export const financeAdmittanceApi = new Admittance(SUB_SYSTEM, 'admittance')
// 付款单信息
export const applyApi = new Admittance('asset', 'payapply')

export const instanceNodeApi = new Admittance('finance/task', 'node')
